<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { BasicDropdown, logClickToGA } from "@urbaninstitute/dataviz-components";
  import { getConfig } from "$lib/utils/config.js";
  import icons from "./header-icons.svg?raw";

  let {
    currentState = $bindable(),
    stateDropdownData,
    stateTextLabel = undefined,
    headerText = "View data for [dropdown]"
  } = $props();
  const config = getConfig()();

  // Split header text on [dropdown] placeholder
  const headerParts = $derived(headerText.split("[dropdown]"));
</script>

<div class="detail-header-wrap">
  <div class="header-icons">
    {@html icons}
  </div>
  <h3 class="detail-header" style:--highlight-color={config.map.hoverStroke}>
    {headerParts[0]}<BasicDropdown
      id="detail-header-state-select"
      inlineLabel="select a state"
      placeholder="select a state"
      data={stateDropdownData}
      bind:value={currentState}
      onchange={(e) => {
        // logClickToGA(e.target, "state-dropdown-select--" + e.target.value);
      }}
      variant="primary"
      dropdownWidth={100}
    />{headerParts[1] || ""}
    {#if currentState && stateTextLabel}
      <span>{stateTextLabel}</span>
    {/if}
  </h3>
</div>

<style>
  .detail-header-wrap {
    background: var(--color-white);
    display: flex;
    gap: var(--spacing-4);
    padding-block: var(--spacing-8);
    border-top: solid 1px var(--color-gray);
    border-bottom: solid 1px var(--color-gray);
    position: sticky;
    top: var(--page-header-height, 0);
    --header-font-size: 36px;
    --select-font-size: 30px;
  }
  .detail-header {
    color: var(--color-gray-shade-darkest);
    line-height: 44px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    column-gap: var(--spacing-2);
    row-gap: 0.875rem;
    /* padding-bottom: var(--spacing-4); */
    margin-top: 0;
    margin-bottom: 0;
    font-weight: var(--font-weight-bold) !important;
    font-size: var(--header-font-size) !important;
    text-transform: none !important;
  }
  /* make dropdowns sit inline */
  .detail-header :global(.dropdown-parent) {
    display: inline-block !important;
    padding: 0 !important;
    transform: translateY(-1px) !important;
  }
  .detail-header :global(.dropdown-container) {
    width: fit-content !important;
  }
  .detail-header :global(.dropdown-container select) {
    font-weight: var(--font-weight-bold);
    font-family: var(--font-family-sans-alt);
    padding-block: var(--spacing-1);
    font-size: var(--select-font-size);
    color: var(--color-gray-shade-darkest);
    background-color: var(--color-gray-shade-lightest) !important;
    border-color: transparent !important;
  }

  .detail-header :global(.dropdown-container .icons) {
    /* padding-right: var(--spacing-1) !important; */
    transform: translateY(-1rem);
  }
  .header-icons {
    padding: var(--spacing-2);
  }
  .header-icons svg {
    display: block;
    width: 100%;
  }
  @media (max-width: 540px) {
    .detail-header-wrap {
      --header-font-size: 28px;
      --select-font-size: 24px;
      display: block;
    }
    .header-icons {
      max-width: 150px;
      display: none;
    }
  }
</style>
